var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shareShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          {
            staticClass: "content",
            class: _vm.classesOfDialog,
            style: _vm.inviteEmailShow ? { height: _vm.emailHeight } : "",
            attrs: { id: "share" }
          },
          [
            _c("div", { staticClass: "title" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("language.popup.cloudExploerPopup.shareWithOthers")
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: { click: _vm.closeDialog }
              })
            ]),
            _vm._v(" "),
            !_vm.inviteEmailShow
              ? _c(
                  "div",
                  {
                    staticClass: "share-content",
                    attrs: { id: "shareContent" }
                  },
                  [
                    _vm._l(_vm.sharetypes, function(shareItem, index) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                index == 1 ||
                                index == 2 ||
                                (index === 3 && _vm.judgeSourceCloud),
                              expression:
                                "index==1||index==2||(index===3&&judgeSourceCloud)"
                            }
                          ],
                          key: index,
                          staticClass: "share-item share-item-checked",
                          style: index == 3 ? "margin-bottom: 15px" : ""
                        },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                _vm.linkCreatedShow == true
                                  ? "share-forbidden"
                                  : _vm.loading
                                  ? "share-forbidden"
                                  : ""
                              ]
                            },
                            [
                              _c("div", { staticClass: "item-title" }, [
                                _c("div", {
                                  staticClass: "icon-util radio radio-position",
                                  class: [
                                    index == _vm.clickCurrent
                                      ? _vm.linkCreatedShow
                                        ? "check-radio-disable"
                                        : _vm.loading
                                        ? "check-radio-disable"
                                        : "check-radio"
                                      : _vm.linkCreatedShow
                                      ? "radio-disable"
                                      : _vm.loading
                                      ? "radio-disable"
                                      : "radio"
                                  ],
                                  on: {
                                    click: function($event) {
                                      return _vm.radioChecked(index, $event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "radio-content" }, [
                                  _vm._v(_vm._s(shareItem.name))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content-tips" }, [
                                _vm._v(_vm._s(shareItem.tips))
                              ]),
                              _vm._v(" "),
                              false
                                ? _c(
                                    "transition",
                                    { attrs: { name: "fade" } },
                                    [
                                      index === _vm.clickCurrent &&
                                      _vm.clickCurrent === 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "content-input-area"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.communityTitle,
                                                    expression: "communityTitle"
                                                  }
                                                ],
                                                staticClass: "email-input",
                                                attrs: {
                                                  type: "text",
                                                  maxlength: "128",
                                                  placeholder: "Title(Optional)"
                                                },
                                                domProps: {
                                                  value: _vm.communityTitle
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.communityTitle =
                                                      $event.target.value
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "text-area" },
                                                [
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.communityDes,
                                                        expression:
                                                          "communityDes"
                                                      }
                                                    ],
                                                    attrs: {
                                                      maxlength: "256",
                                                      placeholder:
                                                        "Description(Optional)"
                                                    },
                                                    domProps: {
                                                      value: _vm.communityDes
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.communityDes =
                                                          $event.target.value
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.linkCreatedShow
                      ? _c("div", { staticClass: "all-copy" }, [
                          _c("div", { staticClass: "copy-button" }, [
                            _c("div", {
                              staticClass:
                                "icon-util share-link share-link-position share-icon"
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.linkUrl,
                                  expression: "linkUrl"
                                }
                              ],
                              staticClass: "site-input",
                              attrs: { readonly: "", id: "linkInput" },
                              domProps: { value: _vm.linkUrl },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.linkUrl = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "site-copy",
                                on: { click: _vm.copySite }
                              },
                              [_vm._v(_vm._s(_vm.$t("language.common.copy")))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "verification-code" }, [
                            _vm.sharePassword
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.sharePassword,
                                      expression: "sharePassword"
                                    }
                                  ],
                                  staticClass: "verification",
                                  attrs: { readonly: "" },
                                  domProps: { value: _vm.sharePassword },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.sharePassword = $event.target.value
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "redit-back" }, [
                              _c("span", { on: { click: _vm.reEdit } }, [
                                _vm._v(_vm._s(_vm.$t("language.popup.redit")))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "all-sns" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  float: "left",
                                  height: "30px",
                                  "line-height": "30px"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.cloudExploerPopup.shareTo"
                                    )
                                  ) + ":\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "sns-icon facebook sns-icon-position",
                              attrs: {
                                title: _vm.$t(
                                  "language.popup.cloudExploerPopup.shareOnFacebook"
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.share($event)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "sns-icon twitter sns-icon-position",
                              attrs: {
                                title: _vm.$t(
                                  "language.popup.cloudExploerPopup.shareOnTwitter"
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.share($event)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "sns-icon tumblr sns-icon-position",
                              attrs: {
                                title: _vm.$t(
                                  "language.popup.cloudExploerPopup.shareOnTumblr"
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.share($event)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "sns-icon pinterest sns-icon-position",
                              attrs: {
                                title: _vm.$t(
                                  "language.popup.cloudExploerPopup.shareOnPinterest"
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.share($event)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "sns-icon ins sns-icon-position",
                              attrs: {
                                title: _vm.$t(
                                  "language.popup.cloudExploerPopup.shareOnLinkedIn"
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.share($event)
                                }
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.linkCreatedShow
                      ? _c(
                          "div",
                          {
                            staticClass: "create-share",
                            style:
                              _vm.clickCurrent === 3
                                ? "margin-top: 40px;"
                                : "margin-top: 26px;"
                          },
                          [
                            _c("div", {
                              staticClass:
                                "icon-util share-link share-link-position"
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "link-created" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.cloudExploerPopup.noLink"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.loading,
                                    expression: "loading"
                                  }
                                ],
                                staticClass: "share-button",
                                on: {
                                  click: function($event) {
                                    return _vm.linkCreated($event)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "language.popup.cloudExploerPopup.createShare"
                                      )
                                    ) +
                                    "\n        "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.inviteEmailShow
              ? _c(
                  "div",
                  {
                    staticClass: "share-content",
                    style: _vm.loadingEmail ? "pointer-events: none;" : "",
                    attrs: { id: "shareMailContent" }
                  },
                  [
                    !_vm.isTransfer
                      ? _c(
                          "div",
                          {
                            staticClass: "share-button-left",
                            on: { click: _vm.letInviteEmailShow }
                          },
                          [
                            _c("div", {
                              staticClass: "icon-util arrow-left-blue"
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "vertical-align": "super" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("language.cloudExploer.back"))
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "share-email-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.cloudExploerPopup.shareEmailTitle"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "invite" }, [
                      _c(
                        "div",
                        { ref: "invite", attrs: { id: "invite" } },
                        [
                          _c("tags-input", {
                            attrs: {
                              message: _vm.$t(
                                "language.popup.cloudExploerPopup.pleaseEnterEmail"
                              ),
                              type: "email"
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          }),
                          _vm._v(" "),
                          _vm.isTransfer
                            ? _c("p", { staticClass: "err tips-info" }, [
                                _vm._v(_vm._s(_vm.tipsMsg.emails))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-area" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.emailMessage,
                                  expression: "emailMessage"
                                }
                              ],
                              attrs: {
                                placeholder: _vm.$t(
                                  "language.popup.cloudExploerPopup.addMessage"
                                ),
                                maxlength: "1000"
                              },
                              domProps: { value: _vm.emailMessage },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.emailMessage = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loadingEmail,
                                  expression: "loadingEmail"
                                }
                              ],
                              staticClass: "share-button",
                              style:
                                _vm.isTransfer && _vm.tipsMsg.emails
                                  ? "margin-top: 0.1rem!important;"
                                  : "",
                              on: {
                                click: function($event) {
                                  return _vm.shareSendEmail()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.cloudExploerPopup.shareSendEmail"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-681ae9d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681ae9d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/share_popup.vue
// module id = null
// module chunks = 